import { ImageProps, MediaType } from '../types';

export const buildStaticImage = ({ name }: { name?: string }) =>
  `https://traegergrills.a.bigcontent.io/v1/static/${encodeURIComponent(name ?? '')}`;

export const buildImageSrc = (
  assetObj?: ImageProps | MediaType | null,
  width?: string | number,
  aspectWidth?: number | null,
  aspectHeight?: number | null,
  url?: string | null,
  quality?: number,
): string => {
  const imageObj = assetObj as ImageProps;
  const mediaObj = assetObj as MediaType;

  if (imageObj?.static && imageObj?.image) {
    return `https://traegergrills.a.bigcontent.io/v1/static/${encodeURIComponent(imageObj.image.name ?? '')}`;
  }
  if (imageObj?.image) {
    return buildImageSrc(imageObj.image, width, aspectWidth, aspectHeight, null, quality);
  }
  const searchParams = new URLSearchParams({
    scaleFit: 'poi',
    fmt: 'webp',
  });

  if (width) {
    searchParams.append('w', String(width));
  }
  if (aspectWidth && aspectHeight) {
    searchParams.append('sm', 'aspect');
    searchParams.append('aspect', `${aspectWidth}:${aspectHeight}`);
  }
  searchParams.append('qlt', 'default');

  url = url || mediaObj?.url;
  if (url) {
    const searchIndex = url.indexOf('?');
    return `${searchIndex === -1 ? url : url.substring(0, searchIndex)}?$poi2$&${searchParams}`;
  }

  if (mediaObj) {
    if (mediaObj.mimeType === 'image/svg+xml') {
      return `https://cdn.graphics.amplience.net/v1/media/graphics/i/${mediaObj.endpoint}/${encodeURIComponent(mediaObj.name ?? '')}`;
    }
    // NOTE: While developing and making edits, add '&v=99' to the end of the url to view
    // the non-cached version of the image.
    return `https://i8.amplience.net/i/${mediaObj.endpoint}/${encodeURIComponent(mediaObj.name ?? '')}?$poi2$&${searchParams}`;
  }

  return `https://i8.amplience.net/i/traeger/image-placeholder-icon-new?$poi2$&${searchParams}`;
};

export default buildImageSrc;
